import { render, staticRenderFns } from "./sky-remarks.vue?vue&type=template&id=702066e3&scoped=true"
import script from "./sky-remarks.vue?vue&type=script&lang=js"
export * from "./sky-remarks.vue?vue&type=script&lang=js"
import style0 from "./sky-remarks.vue?vue&type=style&index=0&id=702066e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702066e3",
  null
  
)

export default component.exports